import { ReferenceField } from "@/components/admin"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from "@/components/ui/item"
import { BadgeCheckIcon, CircleAlert } from "lucide-react"
// import { useResourceContext } from 'ra-core'

interface FullNameFieldProps {
  showVerified?: boolean
}
export const FullNameField = ({ showVerified = true }: FullNameFieldProps) => {
  // const resource = useResourceContext()

  return (
    <ReferenceField
      link={false}
      source="id"
      reference="users"
      render={({ error, isPending, referenceRecord }) => {
        if (isPending) {
          return <p>Loading...</p>
        }
        if (error) {
          return <p className="error">{error.message}</p>
        }
        if (!referenceRecord) {
          return null
        }
        const { first_name, last_name, avatar, email } = referenceRecord
        return (
          <Item variant="outline" className="border-0 p-1.5">
            <ItemMedia>
              <Avatar className="size-12">
                <AvatarImage src={avatar?.src} />
                <AvatarFallback>
                  {first_name?.charAt(0)}
                  {last_name?.charAt(0)}
                </AvatarFallback>
              </Avatar>
              <span className="absolute -top-0.5 -right-1.5">
                <span className="sr-only">Verified</span>
                {showVerified ? (
                  first_name && last_name ? (
                    <BadgeCheckIcon className="text-background size-5 fill-sky-500" />
                  ) : (
                    <CircleAlert className="text-background size-5 fill-orange-500" />
                  )
                ) : null}
              </span>
            </ItemMedia>
            <ItemContent>
              <ItemTitle>{`${first_name || ""} ${last_name || ""}`}</ItemTitle>
              <ItemDescription>{email}</ItemDescription>
            </ItemContent>
          </Item>
        )
      }}
    />
  )
}
